export const throwError = message => {
	throw new Error(message);
};
